<template>
  <!-- 添加一个组页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <config-hang @click.native="regionSelectBtnHandle">
        <span slot="config_hang_ele2">区域筛选</span>
        <img slot="config_hang_ele4"
             src="~assets/img/config/youjiantou.png"
             alt />
      </config-hang>

      <config-title-hang>
        <span slot="config_title_hang_ele2">筛选列表</span>
        <input slot="config_title_hang_ele7"
               type="text"
               placeholder="快速搜索"
               v-model="scerchValue">
        <span slot="config_title_hang_ele6"
              @click="allRegionOperate(0)">取消所有</span>
        <span slot="config_title_hang_ele5"
              @click="allRegionOperate(1)">选择所有</span>
      </config-title-hang>

      <config-hang v-for="(value, index) in OneGroupRuleObjectRegionList.groupDeviceList"
                   :key="index"
                   :selectState="value.checked"
                   @click.native="configHangSelectGroupObjectBtnHandle(value)">
        <span slot="config_hang_ele2">{{value.remark}}({{value.regionName}})</span>
        <img slot="config_hang_weixuan"
             src="~assets/img/config/weixuan.png"
             alt />
        <img slot="config_hang_xuanzhong"
             src="~assets/img/config/xuanzhong.png"
             alt />

        <img v-if="value.passwordState === 1"
             slot="config_hang_mimatishiimg"
             src="~assets/img/config/mimatishi.png"
             alt />
      </config-hang>

      <div class="public_config_que_ren_btn"
           @click="configQueRenBtn">保存并返回</div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data () {
    return {
      OneGroupinfo: {
        ////虚拟的一个组仓库信息，实际在页面加载过程中指向了仓库
        deleteState: 1,
        followState: null,
        iconId: "",
        iconUrl: "",
        regionId: "",
        regionName: "请选择一个区域",
        deviceId: "",
        deviceName: "",
        groupNo: null
      },
      OneGroupRuleObjectRegionList: {
        //页面加载指向服务器获取的仓库地址数据
        ruleList: [],
        groupDeviceList: [],
        groupRegionList: []
      },
      OneGroupRuleObjectRegionListBack: {
        //页面加载指向服务器获取的仓库地址数据 用来搜索备份
        ruleList: [],
        groupDeviceList: [],
        groupRegionList: []
      },
      scerchValue: "", // 搜索使用
      checkDeviceList: [], /////选中设备的list，需要存到仓库实时更新
      branchCheckDeviceList: [], /////分支的选中设备的list，仓库没有，出页面之前需要汇到checkDeviceList
      branchNoCheckDeviceList: [] /////分支未选中设备的list，仓库没有，出页面之前需要汇到checkDeviceList,

    };
  },
  computed: {},
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    configQueRenBtn () {
      console.log(this.OneGroupRuleObjectRegionList.ruleList);
      this.checkDeviceListHandle(); ///更新最新的选中设备数组

      console.log(this.checkDeviceList);

      /// 请求区域信息接口，获取数据
      this.$request({
        method: "post",
        url: "/userGroup/handleDeviceRuleList",
        data: {
          token: this.$store.state.token,
          // ruleList: this.OneGroupRuleObjectRegionList.ruleList,
          ruleList: this.$store.state.configinfo.OneGroupRuleList,
          checkDeviceList: this.checkDeviceList
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.ServeGroupRule = res.data.data; ////拿到服务器返回的数据结果
            this.$store.dispatch(
              "asyUpdataOneGroupRuleList",
              res.data.data.ruleList
            ); ////把服务器获取到的规则列表地址存到仓库
            console.log(res.data.data);
            //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面
            this.$router.go(-1);
            // this.$router.push("ConfigAddGroupRule");
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    configHangSelectGroupObjectBtnHandle (value) {
      console.log("一个对象被点击了");
      console.log(value);
      if (value.passwordState === 1) {
        ////只要passwordState === 1 就需要进行密码验证 成功才允许勾选或取消勾选
        this.$showTipsToast(16, value);
      } else {
        value.checked = !value.checked;
        console.log(this.OneGroupRuleObjectRegionList.groupDeviceList);
      }
    },
    regionSelectBtnHandle () {
      ///区域筛选按钮被点击了
      this.checkDeviceListHandle(); ///更新最新的选中设备数组

      this.$router.push("ConfigSelectGroupObjectRegion");
      console.log(this.checkDeviceList)
    },
    checkDeviceListHandle () {
      ///处理一下当前页面选中的设备的ID，得到分支选中的设备ID
      this.branchCheckDeviceList.length = 0;
      this.branchNoCheckDeviceList.length = 0;
      // console.log(this.OneGroupRuleObjectRegionList.groupDeviceList.length)
      let length = this.OneGroupRuleObjectRegionList.groupDeviceList.length;
      let checkLength = 0;
      let nocheckLength = 0;
      // console.log(length)
      for (let i = 0; i < length; i++) {
        if (
          this.OneGroupRuleObjectRegionList.groupDeviceList[i].checked === true
        ) {
          ///拿到分支选中的设备ID
          this.branchCheckDeviceList[
            checkLength
          ] = this.OneGroupRuleObjectRegionList.groupDeviceList[i].deviceId;
          checkLength++;
        } else {
          ///拿到分支未选中的设备ID
          this.branchNoCheckDeviceList[
            nocheckLength
          ] = this.OneGroupRuleObjectRegionList.groupDeviceList[i].deviceId;
          nocheckLength++;
        }
      }
      console.log(this.branchCheckDeviceList);  //分支选中的设备ID
      console.log(this.checkDeviceList);
      ////把分支选中的设备ID和仓库的合并更新到仓库
      ////	合并数组去掉分支未选中的设备ID
      this.branchDelete();
      // 合并数组添加选中的设备ID
      this.checkDeviceList.push(...this.branchCheckDeviceList);
      console.log(this.checkDeviceList);
      // ///数组去重，得到最新的
      this.checkDeviceList = [...new Set(this.checkDeviceList)];
      console.log(this.checkDeviceList);
      // console.log(this.$store.state.configinfo)

      // this.$store.dispatch("asyUpdataCheckDeviceList", this.checkDeviceList); ///异步提交选中的设备ID到仓库
      this.$store.dispatch('asyUpdataCheckDeviceList', this.checkDeviceList) ///异步提交选中的设备ID到仓库
      // console.log(this.$store.state.configinfo)
    },
    branchDelete () {
      console.log(this.checkDeviceList)
      // ///数组去重，得到最新的 20200509- 补BUG 解决当有多条时，勾选删不掉的情况
      this.checkDeviceList = [...new Set(this.checkDeviceList)];
      console.log(this.checkDeviceList);

      let checkDeviceListlength = this.checkDeviceList.length;
      let branchNoCheckDeviceListlength = this.branchNoCheckDeviceList.length;
      for (let i = 0; i < checkDeviceListlength; i++) {
        for (let l = 0; l < branchNoCheckDeviceListlength; l++) {
          if (this.checkDeviceList[i] === this.branchNoCheckDeviceList[l]) {
            this.checkDeviceList.splice(i, 1); ///删掉未勾选的
            checkDeviceListlength--;
          }
        }
      }
      console.log(this.checkDeviceList)
    },
    allRegionOperate (data) {
      //  代号20200731-4 
      let regionLength = this.OneGroupRuleObjectRegionList.groupDeviceList.length
      if (data == 0) {
        //s说明是取消所有的设备
        for (let i = 0; i < regionLength; i++) {
          this.OneGroupRuleObjectRegionList.groupDeviceList[i].checked = false;
        }
      } else if (data == 1) {
        //说明是选择所有的设备
        for (let i = 0; i < regionLength; i++) {
          this.OneGroupRuleObjectRegionList.groupDeviceList[i].checked = true;
        }
      }
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow (charData) {
      if (
        this.OneGroupRuleObjectRegionList.groupDeviceList &&
        this.OneGroupRuleObjectRegionListBack.groupDeviceList
      ) {
        //数据是合法存在的
        this.OneGroupRuleObjectRegionList.groupDeviceList = this.OneGroupRuleObjectRegionList.groupDeviceList.concat(
          this.OneGroupRuleObjectRegionListBack.groupDeviceList
        );
        this.OneGroupRuleObjectRegionListBack.groupDeviceList.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.OneGroupRuleObjectRegionList.groupDeviceList.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              (
                this.OneGroupRuleObjectRegionList.groupDeviceList[i].remark +
                this.OneGroupRuleObjectRegionList.groupDeviceList[i].regionName
              ).indexOf(charData) == -1
            ) {
              // && this.OneGroupRuleObjectRegionList.groupDeviceList[i].checked == false
              // 说明没有这个字符
              this.OneGroupRuleObjectRegionListBack.groupDeviceList.push(
                this.OneGroupRuleObjectRegionList.groupDeviceList[i]
              );
              this.OneGroupRuleObjectRegionList.groupDeviceList.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.OneGroupRuleObjectRegionList.groupDeviceList);
      }
    }
  },
  mounted () {
    console.log("mounted阶段");
  },
  created () {
    console.log("created阶段");

    //// 把仓库的一个组信息的地址拿过来  拿的是地址  并不是数据
    // this.OneGroupinfo = this.$store.state.configinfo.OneGroupinfo;
    ///把仓库的一个组的规则区域对象拿过来
    this.OneGroupRuleObjectRegionList = this.$store.state.configinfo.OneGroupRuleObjectRegionList;
    // 用来数据搜索 深度拷贝
    // objectClone(this.OneGroupRuleObjectRegionListBack,this.OneGroupRuleObjectRegionList )

    ///把仓库存储的 一条组信息的勾选对象地址拿过来
    // console.log(this.$store.state.configinfo.OneGroupRuleList);
    this.checkDeviceList = this.$store.state.configinfo.checkDeviceList;
  },
  destroyed () {
    //页面销毁之前
    console.log("页面即将销毁")
    // 销毁页面之前 恢复数据  数据搜索
    this.scerchValue = "";
    if (this.OneGroupRuleObjectRegionListBack.groupDeviceList.length != 0) {
      //所有搜索备份的数据还没有完全恢复
      this.OneGroupRuleObjectRegionList.groupDeviceList = this.OneGroupRuleObjectRegionList.groupDeviceList.concat(this.OneGroupRuleObjectRegionListBack.groupDeviceList);
      this.OneGroupRuleObjectRegionListBack.groupDeviceList.length = 0;
    }
  }
};
</script>

<style>
.config_select_group_object_title_height {
  height: 15px;
}
/* .config_select_group_object_hang_height{
  height: 80px;
} */
</style>